export default function triggerEvent(el, type) {
  if ('createEvent' in document) {
    // modern browsers, IE9+
    var e = document.createEvent('HTMLEvents');
    e.initEvent(type, false, true);
    el.dispatchEvent(e);
  }
}


//////////////////
// WEBPACK FOOTER
// ../~/antd/es/_util/triggerEvent.js
// module id = 707
// module chunks = 0